const DOG_PROFILE_STORAGE_KEY = 'dragonfly:dog-profile:v1';
const DOG_PROFILE_EVENT = 'dragonfly:dog-profile-change';

const DOG_PROFILE_SIZES = {
  small: {
    id: 'small',
    label: 'Small',
    weight: 'under 15 kg',
    breeds: 'Westie, Beagle',
    scale: 18,
    metafield: 'Small Breed',
  },
  medium: {
    id: 'medium',
    label: 'Standard',
    weight: '15–25 kg',
    breeds: 'Spaniel, Collie',
    scale: 26,
    metafield: 'Standard Breed',
  },
  large: {
    id: 'large',
    label: 'Large',
    weight: '25–40 kg',
    breeds: 'Lab, Retriever',
    scale: 35,
    metafield: 'Large Breed',
  },
  giant: {
    id: 'giant',
    label: 'Giant',
    weight: '40+ kg',
    breeds: 'Great Dane, Mastiff',
    scale: 44,
    metafield: 'Giant Breed',
  },
};

const DOG_PROFILE_AGES = {
  puppy: { id: 'puppy', label: 'Puppy', sub: 'Under 12 months', emoji: '🐾' },
  junior: { id: 'junior', label: 'Junior', sub: '1–2 years', emoji: '🏃' },
  adult: { id: 'adult', label: 'Adult', sub: '2–7 years', emoji: '⭐' },
  senior: { id: 'senior', label: 'Senior', sub: '7+ years', emoji: '🌿' },
};

const DOG_PROFILE_BREED_SHORTCUTS = ['Mixed breed', "Don't know"];

/** Nicknames / misspellings → canonical breed name from DOG_PROFILE_BREEDS */
const DOG_PROFILE_BREED_ALIASES = {
  'alsatian': 'German Shepherd',
  'aussie': 'Australian Shepherd',
  'berner': 'Bernese Mountain Dog',
  'bernese': 'Bernese Mountain Dog',
  'blue heeler': 'Australian Cattle Dog',
  'bulldog': 'British Bulldog',
  'cav': 'Cavalier King Charles Spaniel',
  'cavalier': 'Cavalier King Charles Spaniel',
  'cocker': 'Cocker Spaniel',
  'dash hound': 'Dachshund',
  'dashound': 'Dachshund',
  'dashhound': 'Dachshund',
  'dobe': 'Dobermann',
  'doberman': 'Dobermann',
  'doberman pinscher': 'Dobermann',
  'doxie': 'Dachshund',
  'english bull': 'English Bulldog',
  'flat coat': 'Flat-Coated Retriever',
  'flat coated retriever': 'Flat-Coated Retriever',
  'flatcoat': 'Flat-Coated Retriever',
  'frenchie': 'French Bulldog',
  'golden': 'Golden Retriever',
  'goldie': 'Golden Retriever',
  'gsd': 'German Shepherd',
  'heeler': 'Australian Cattle Dog',
  'jack russell': 'Jack Russell Terrier',
  'jrt': 'Jack Russell Terrier',
  'king charles': 'Cavalier King Charles Spaniel',
  'lab': 'Labrador Retriever',
  'labrador': 'Labrador Retriever',
  'malinois': 'Belgian Malinois',
  'min pin': 'Miniature Pinscher',
  'mini dachshund': 'Miniature Dachshund',
  'mini sausage dog': 'Miniature Dachshund',
  'miniature sausage dog': 'Miniature Dachshund',
  'newfie': 'Newfoundland',
  'pom': 'Pomeranian',
  'retriever': 'Labrador Retriever',
  'ridgeback': 'Rhodesian Ridgeback',
  'rottie': 'Rottweiler',
  'rough collie': 'Rough Collie',
  'saint bernard': 'St. Bernard',
  'sausage': 'Dachshund',
  'sausage dog': 'Dachshund',
  'schnauzer': 'Miniature Schnauzer',
  'scottie': 'Scottish Terrier',
  'scotty': 'Scottish Terrier',
  'sheltie': 'Shetland Sheepdog',
  'shihtzu': 'Shih Tzu',
  'shitzu': 'Shih Tzu',
  'springer': 'Springer Spaniel',
  'st bernard': 'St. Bernard',
  'staff': 'Staffordshire Bull Terrier',
  'staffie': 'Staffordshire Bull Terrier',
  'staffy': 'Staffordshire Bull Terrier',
  'vizsla': 'Hungarian Vizsla',
  'westie': 'West Highland White Terrier',
  'wiener dog': 'Dachshund',
  'yorkie': 'Yorkshire Terrier',
};

const DOG_PROFILE_BREEDS = [
  'Affenpinscher',
  'Afghan Hound',
  'Airedale Terrier',
  'Akita',
  'Alaskan Malamute',
  'American Bulldog',
  'Australian Cattle Dog',
  'Australian Shepherd',
  'Basenji',
  'Basset Hound',
  'Beagle',
  'Bearded Collie',
  'Bedlington Terrier',
  'Belgian Malinois',
  'Bernese Mountain Dog',
  'Bichon Frise',
  'Border Collie',
  'Border Terrier',
  'Boston Terrier',
  'Boxer',
  'Briard',
  'British Bulldog',
  'Brittany',
  'Cairn Terrier',
  'Cane Corso',
  'Cavalier King Charles Spaniel',
  'Cavapoo',
  'Chihuahua',
  'Chinese Crested',
  'Chow Chow',
  'Cockapoo',
  'Cocker Spaniel',
  'Collie',
  'Corgi',
  'Dachshund',
  'Dalmatian',
  'Dobermann',
  "Don't know",
  'English Bulldog',
  'English Setter',
  'English Springer Spaniel',
  'Field Spaniel',
  'Flat-Coated Retriever',
  'French Bulldog',
  'German Shepherd',
  'German Shorthaired Pointer',
  'Giant Schnauzer',
  'Golden Retriever',
  'Goldendoodle',
  'Gordon Setter',
  'Great Dane',
  'Greyhound',
  'Hungarian Vizsla',
  'Husky',
  'Irish Setter',
  'Irish Terrier',
  'Irish Wolfhound',
  'Italian Greyhound',
  'Jack Russell Terrier',
  'Japanese Spitz',
  'Labradoodle',
  'Labrador Retriever',
  'Lhasa Apso',
  'Lurcher',
  'Maltese',
  'Maltipoo',
  'Mastiff',
  'Miniature Dachshund',
  'Miniature Pinscher',
  'Miniature Poodle',
  'Miniature Schnauzer',
  'Mixed breed',
  'Newfoundland',
  'Norfolk Terrier',
  'Norwegian Elkhound',
  'Old English Sheepdog',
  'Papillon',
  'Parson Russell Terrier',
  'Patterdale Terrier',
  'Pekingese',
  'Pointer',
  'Pomeranian',
  'Poodle',
  'Pug',
  'Puggle',
  'Rhodesian Ridgeback',
  'Rottweiler',
  'Rough Collie',
  'Saluki',
  'Samoyed',
  'Scottish Terrier',
  'Shar Pei',
  'Shetland Sheepdog',
  'Shiba Inu',
  'Shih Tzu',
  'Siberian Husky',
  'Soft Coated Wheaten Terrier',
  'Springer Spaniel',
  'Staffordshire Bull Terrier',
  'Standard Poodle',
  'St. Bernard',
  'Tibetan Spaniel',
  'Tibetan Terrier',
  'Toy Poodle',
  'Weimaraner',
  'Welsh Terrier',
  'West Highland White Terrier',
  'Whippet',
  'Yorkshire Terrier',
];

function readDogProfile() {
  try {
    const raw = window.localStorage.getItem(DOG_PROFILE_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || !DOG_PROFILE_SIZES[parsed.size] || !DOG_PROFILE_AGES[parsed.age]) return null;
    return {
      size: parsed.size,
      age: parsed.age,
      name: typeof parsed.name === 'string' ? parsed.name.trim() : '',
      breed: typeof parsed.breed === 'string' ? parsed.breed.trim() : '',
    };
  } catch (error) {
    return null;
  }
}

function writeDogProfile(profile) {
  if (!profile) {
    window.localStorage.removeItem(DOG_PROFILE_STORAGE_KEY);
  } else {
    window.localStorage.setItem(DOG_PROFILE_STORAGE_KEY, JSON.stringify(profile));
  }

  window.dispatchEvent(
    new CustomEvent(DOG_PROFILE_EVENT, {
      detail: { profile },
    })
  );
}

function normalizeSizeToken(value) {
  const text = String(value || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');

  if (!text) return '';
  if (text.includes('giant')) return 'giant';
  if (text.includes('large')) return 'large';
  if (text.includes('standard') || text.includes('medium')) return 'medium';
  if (text.includes('small') || text.includes('toy') || text.includes('xs')) return 'small';
  return '';
}

function normalizeAgeToken(value) {
  const text = String(value || '')
    .trim()
    .toLowerCase();

  if (!text) return '';
  if (text.includes('puppy') || text.includes('pup')) return 'puppy';
  if (text.includes('junior') || text.includes('young')) return 'junior';
  if (text.includes('senior') || text.includes('old')) return 'senior';
  if (text.includes('adult')) return 'adult';
  return '';
}

function parseTokenList(value) {
  if (!value) return [];
  return String(value)
    .split(',')
    .map((token) => token.trim())
    .filter(Boolean);
}

function isDisplayBreed(breed) {
  const value = String(breed || '').trim().toLowerCase();
  if (!value) return false;
  if (value === "don't know" || value === 'dont know' || value === 'prefer not to say') return false;
  return true;
}

function normalizeBreedQuery(value) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');
}

function resolveBreedAlias(value) {
  const trimmed = String(value || '').trim();
  if (!trimmed) return '';

  const exactAlias = DOG_PROFILE_BREED_ALIASES[normalizeBreedQuery(trimmed)];
  if (exactAlias) return exactAlias;

  const exactBreed = DOG_PROFILE_BREEDS.find(
    (breed) => breed.toLowerCase() === normalizeBreedQuery(trimmed)
  );
  if (exactBreed) return exactBreed;

  return trimmed;
}

function breedMatchesQuery(breed, needle) {
  if (!needle) return true;

  const breedLower = breed.toLowerCase();
  if (breedLower.includes(needle)) return true;

  return Object.entries(DOG_PROFILE_BREED_ALIASES).some(([alias, canonical]) => {
    if (canonical !== breed) return false;
    return alias.includes(needle) || (needle.length >= 3 && alias.startsWith(needle));
  });
}

if (!customElements.get('dog-profile')) {
  customElements.define(
    'dog-profile',
    class DogProfile extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.displayMode = this.dataset.displayMode || 'full';
        this.showProductRow = this.dataset.showProductRow === 'true';
        this.productsLimit = Number(this.dataset.productsLimit || 5);
        this.sectionId = this.dataset.sectionId || '';

        this.pendingSize = null;
        this.pendingAge = null;
        this.pendingName = '';
        this.pendingBreed = '';
        this.breedActiveIndex = -1;
        this.expanded = false;
        this.profile = readDogProfile();

        this.cacheElements();
        this.bindEvents();
        this.syncFromProfile(this.profile, { expandIfEditing: false });
        this.classList.add('is-ready');
        document.querySelectorAll('dog-profile').forEach((el) => {
          if (el !== this && typeof el.render === 'function') el.render();
        });

        this.onProfileChange = (event) => {
          this.syncFromProfile(event.detail?.profile ?? readDogProfile(), { expandIfEditing: false });
        };
        this.onStorage = (event) => {
          if (event.key && event.key !== DOG_PROFILE_STORAGE_KEY) return;
          this.syncFromProfile(readDogProfile(), { expandIfEditing: false });
        };

        window.addEventListener(DOG_PROFILE_EVENT, this.onProfileChange);
        window.addEventListener('storage', this.onStorage);

        this.onEditRequest = () => {
          if (this.displayMode === 'row_only') return;
          if (!this.profile) return;
          this.handleEdit();
        };
        window.addEventListener('dragonfly:dog-profile-edit', this.onEditRequest);
      }

      disconnectedCallback() {
        window.removeEventListener(DOG_PROFILE_EVENT, this.onProfileChange);
        window.removeEventListener('storage', this.onStorage);
        window.removeEventListener('dragonfly:dog-profile-edit', this.onEditRequest);
      }

      cacheElements() {
        this.setupEl = this.querySelector('[data-dog-profile-setup]');
        this.bannerEl = this.querySelector('[data-dog-profile-banner]');
        this.wizardEl = this.querySelector('[data-dog-profile-wizard]');
        this.rowEl = this.querySelector('[data-dog-profile-row]');
        this.emptyEl = this.querySelector('[data-dog-profile-empty]');
        this.nameInput = this.querySelector('[data-dog-profile-name]');
        this.breedInput = this.querySelector('[data-dog-profile-breed]');
        this.breedList = this.querySelector('[data-dog-profile-breed-list]');
        this.breedChips = Array.from(this.querySelectorAll('[data-dog-profile-breed-chip]'));
        this.confirmBtn = this.querySelector('[data-dog-profile-confirm]');
        this.cancelBtn = this.querySelector('[data-dog-profile-cancel]');
        this.sizeButtons = Array.from(this.querySelectorAll('[data-dog-profile-size]'));
        this.ageButtons = Array.from(this.querySelectorAll('[data-dog-profile-age]'));
        this.candidates = Array.from(this.querySelectorAll('[data-dog-profile-candidate]'));
        this.gridEl = this.querySelector('[data-dog-profile-grid]');
      }

      bindEvents() {
        this.sizeButtons.forEach((button) => {
          button.addEventListener('click', () => {
            this.pendingSize = button.dataset.dogProfileSize;
            this.updateWizardSelection();
          });
        });

        this.ageButtons.forEach((button) => {
          button.addEventListener('click', () => {
            this.pendingAge = button.dataset.dogProfileAge;
            this.updateWizardSelection();
          });
        });

        this.nameInput?.addEventListener('input', () => {
          this.pendingName = this.nameInput.value;
          this.updateConfirmLabel();
        });

        this.breedInput?.addEventListener('input', () => {
          this.pendingBreed = this.breedInput.value;
          this.breedActiveIndex = -1;
          this.updateBreedChips();
          this.renderBreedSuggestions();
          this.updateConfirmLabel();
        });

        this.breedInput?.addEventListener('focus', () => {
          this.renderBreedSuggestions();
        });

        this.breedInput?.addEventListener('keydown', (event) => this.onBreedKeydown(event));

        this.breedInput?.addEventListener('blur', () => {
          window.setTimeout(() => this.hideBreedSuggestions(), 150);
        });

        this.breedChips.forEach((chip) => {
          chip.addEventListener('click', () => {
            this.setPendingBreed(chip.dataset.dogProfileBreedChip || '');
            this.hideBreedSuggestions();
          });
        });

        this.confirmBtn?.addEventListener('click', () => this.handleConfirm());
        this.cancelBtn?.addEventListener('click', () => {
          this.expanded = false;
          this.hideBreedSuggestions();
          this.render();
        });

        this.querySelectorAll('[data-dog-profile-edit]').forEach((button) => {
          button.addEventListener('click', () => this.handleEdit());
        });

        this.querySelectorAll('[data-dog-profile-clear]').forEach((button) => {
          button.addEventListener('click', () => this.handleClear());
        });

        this.querySelectorAll('[data-dog-profile-open]').forEach((button) => {
          button.addEventListener('click', () => {
            this.pendingSize = null;
            this.pendingAge = null;
            this.pendingName = '';
            this.pendingBreed = '';
            if (this.nameInput) this.nameInput.value = '';
            if (this.breedInput) this.breedInput.value = '';
            this.updateBreedChips();
            this.expanded = true;
            this.render();
            this.wizardEl?.focus({ preventScroll: true });
          });
        });
      }

      setPendingBreed(value) {
        this.pendingBreed = resolveBreedAlias(value);
        if (this.breedInput) this.breedInput.value = this.pendingBreed;
        this.updateBreedChips();
        this.updateConfirmLabel();
      }

      syncFromProfile(profile, { expandIfEditing = false } = {}) {
        this.profile = profile;

        if (!this.profile) {
          this.pendingSize = null;
          this.pendingAge = null;
          this.pendingName = '';
          this.pendingBreed = '';
          if (this.nameInput) this.nameInput.value = '';
          if (this.breedInput) this.breedInput.value = '';
          this.expanded = this.displayMode === 'full';
        } else if (expandIfEditing) {
          this.pendingSize = this.profile.size;
          this.pendingAge = this.profile.age;
          this.pendingName = this.profile.name || '';
          this.pendingBreed = this.profile.breed || '';
          if (this.nameInput) this.nameInput.value = this.pendingName;
          if (this.breedInput) this.breedInput.value = this.pendingBreed;
          this.expanded = true;
        } else if (!this.expanded) {
          this.pendingSize = this.profile.size;
          this.pendingAge = this.profile.age;
          this.pendingName = this.profile.name || '';
          this.pendingBreed = this.profile.breed || '';
          if (this.nameInput) this.nameInput.value = this.pendingName;
          if (this.breedInput) this.breedInput.value = this.pendingBreed;
        }

        this.updateBreedChips();
        this.render();
      }

      handleEdit() {
        if (!this.profile) return;

        if (this.displayMode === 'row_only') {
          window.dispatchEvent(new CustomEvent('dragonfly:dog-profile-edit'));
          return;
        }

        this.pendingSize = this.profile.size;
        this.pendingAge = this.profile.age;
        this.pendingName = this.profile.name || '';
        this.pendingBreed = this.profile.breed || '';
        if (this.nameInput) this.nameInput.value = this.pendingName;
        if (this.breedInput) this.breedInput.value = this.pendingBreed;
        this.updateBreedChips();
        this.expanded = true;
        this.render();
        this.wizardEl?.focus({ preventScroll: true });
        this.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      handleClear() {
        writeDogProfile(null);
        this.syncFromProfile(null);
        this.wizardEl?.focus({ preventScroll: true });
      }

      handleConfirm() {
        if (!this.pendingSize || !this.pendingAge) return;

        const nextProfile = {
          size: this.pendingSize,
          age: this.pendingAge,
          name: (this.pendingName || '').trim(),
          breed: resolveBreedAlias(this.pendingBreed || this.breedInput?.value || ''),
        };

        this.expanded = false;
        this.hideBreedSuggestions();
        writeDogProfile(nextProfile);
        this.syncFromProfile(nextProfile);
      }

      updateWizardSelection() {
        this.sizeButtons.forEach((button) => {
          const selected = button.dataset.dogProfileSize === this.pendingSize;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });

        this.ageButtons.forEach((button) => {
          const selected = button.dataset.dogProfileAge === this.pendingAge;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });

        this.updateBreedChips();
        this.updateConfirmLabel();
      }

      updateBreedChips() {
        const current = (this.pendingBreed || '').trim().toLowerCase();
        this.breedChips.forEach((chip) => {
          const value = (chip.dataset.dogProfileBreedChip || '').trim().toLowerCase();
          chip.classList.toggle('is-selected', Boolean(current) && current === value);
        });
      }

      updateConfirmLabel() {
        if (!this.confirmBtn) return;
        const canConfirm = Boolean(this.pendingSize && this.pendingAge);
        this.confirmBtn.disabled = !canConfirm;

        const name = (this.pendingName || '').trim();
        const confirmTemplate = this.dataset.confirmLabel || 'Show treats for [name]';
        const disabledLabel = this.dataset.disabledLabel || 'Select size and age above';
        const fallbackName = this.dataset.fallbackName || 'my dog';

        this.confirmBtn.textContent = canConfirm
          ? confirmTemplate.replace('[name]', name || fallbackName)
          : disabledLabel;
      }

      dogLabel() {
        const name = this.profile?.name;
        const breed = this.profile?.breed;
        const fallback = this.dataset.yourDogLabel || 'your dog';

        if (name) return name;
        if (isDisplayBreed(breed)) return breed;
        return fallback;
      }

      matchingCandidates({ allowSizeFallback = true } = {}) {
        if (!this.profile) {
          return { items: [], mode: 'none' };
        }

        const exact = this.candidates.filter((item) => {
          const sizes = parseTokenList(item.dataset.sizes).map(normalizeSizeToken).filter(Boolean);
          const ages = parseTokenList(item.dataset.ages).map(normalizeAgeToken).filter(Boolean);
          return sizes.includes(this.profile.size) && ages.includes(this.profile.age);
        });

        if (exact.length || !allowSizeFallback) {
          return { items: exact, mode: exact.length ? 'exact' : 'none' };
        }

        const sizeOnly = this.candidates.filter((item) => {
          const sizes = parseTokenList(item.dataset.sizes).map(normalizeSizeToken).filter(Boolean);
          return sizes.includes(this.profile.size);
        });

        if (sizeOnly.length) {
          return { items: sizeOnly, mode: 'size' };
        }

        return { items: [], mode: 'none' };
      }

      filterBreeds(query) {
        const needle = normalizeBreedQuery(query);

        if (!needle) {
          return DOG_PROFILE_BREEDS.filter((breed) => DOG_PROFILE_BREED_SHORTCUTS.includes(breed)).concat(
            DOG_PROFILE_BREEDS.filter((breed) => !DOG_PROFILE_BREED_SHORTCUTS.includes(breed)).slice(0, 8)
          );
        }

        const aliasHit = DOG_PROFILE_BREED_ALIASES[needle];
        const matches = DOG_PROFILE_BREEDS.filter((breed) => breedMatchesQuery(breed, needle));

        if (aliasHit && !matches.includes(aliasHit)) {
          matches.unshift(aliasHit);
        } else if (aliasHit) {
          matches.splice(matches.indexOf(aliasHit), 1);
          matches.unshift(aliasHit);
        }

        return matches.slice(0, 8);
      }

      renderBreedSuggestions() {
        if (!this.breedList || !this.breedInput) return;

        const matches = this.filterBreeds(this.breedInput.value);
        this.breedList.innerHTML = '';

        if (!matches.length) {
          this.hideBreedSuggestions();
          return;
        }

        matches.forEach((breed, index) => {
          const item = document.createElement('li');
          item.setAttribute('role', 'option');
          item.id = `DogProfileBreedOption-${this.sectionId}-${index}`;

          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'dog-profile__breed-option';
          button.textContent = breed;
          button.dataset.breed = breed;
          if (index === this.breedActiveIndex) button.classList.add('is-active');
          button.addEventListener('mousedown', (event) => {
            event.preventDefault();
            this.setPendingBreed(breed);
            this.hideBreedSuggestions();
          });

          item.appendChild(button);
          this.breedList.appendChild(item);
        });

        this.breedList.hidden = false;
        this.breedInput.setAttribute('aria-expanded', 'true');
      }

      hideBreedSuggestions() {
        if (!this.breedList || !this.breedInput) return;
        this.breedList.hidden = true;
        this.breedList.innerHTML = '';
        this.breedActiveIndex = -1;
        this.breedInput.setAttribute('aria-expanded', 'false');
      }

      onBreedKeydown(event) {
        if (!this.breedList || this.breedList.hidden) {
          if (event.key === 'ArrowDown') {
            this.renderBreedSuggestions();
            event.preventDefault();
          }
          return;
        }

        const options = Array.from(this.breedList.querySelectorAll('.dog-profile__breed-option'));
        if (!options.length) return;

        if (event.key === 'ArrowDown') {
          event.preventDefault();
          this.breedActiveIndex = (this.breedActiveIndex + 1) % options.length;
          this.syncBreedActiveOption(options);
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          this.breedActiveIndex = this.breedActiveIndex <= 0 ? options.length - 1 : this.breedActiveIndex - 1;
          this.syncBreedActiveOption(options);
        } else if (event.key === 'Enter' && this.breedActiveIndex >= 0) {
          event.preventDefault();
          this.setPendingBreed(options[this.breedActiveIndex].dataset.breed || '');
          this.hideBreedSuggestions();
        } else if (event.key === 'Escape') {
          this.hideBreedSuggestions();
        }
      }

      syncBreedActiveOption(options) {
        options.forEach((option, index) => {
          option.classList.toggle('is-active', index === this.breedActiveIndex);
        });
      }

      render() {
        const hasProfile = Boolean(this.profile);
        const hasSiteBanner = Boolean(document.querySelector('dog-profile[data-display-mode="banner_only"]'));
        const hasFullWizard = Boolean(document.querySelector('dog-profile[data-display-mode="full"]'));
        const showWizard = this.expanded && this.displayMode !== 'row_only';
        const showBanner =
          hasProfile &&
          !showWizard &&
          this.displayMode !== 'row_only' &&
          !(this.displayMode === 'full' && hasSiteBanner);
        const showSetup =
          !hasProfile &&
          !showWizard &&
          (this.displayMode === 'compact' || this.displayMode === 'banner_only') &&
          !(this.displayMode === 'banner_only' && hasFullWizard);

        this.setupEl?.toggleAttribute('hidden', !showSetup);
        this.bannerEl?.toggleAttribute('hidden', !showBanner);
        this.wizardEl?.toggleAttribute('hidden', !showWizard);
        this.cancelBtn?.toggleAttribute('hidden', !(showWizard && hasProfile));
        this.toggleAttribute(
          'hidden',
          !showSetup && !showBanner && !showWizard && !(this.showProductRow && hasProfile)
        );

        this.classList.toggle('dog-profile--has-profile', hasProfile);
        this.classList.toggle('dog-profile--expanded', showWizard);
        this.classList.toggle('dog-profile--row-only', this.displayMode === 'row_only');
        this.classList.toggle('dog-profile--banner-only', this.displayMode === 'banner_only');

        this.updateWizardSelection();
        this.renderBanner();
        this.renderProductRow();
      }

      renderBanner() {
        if (!this.bannerEl || !this.profile) return;

        const sizeInfo = DOG_PROFILE_SIZES[this.profile.size];
        const ageInfo = DOG_PROFILE_AGES[this.profile.age];
        const { items: matches } = this.matchingCandidates();

        const nameEl = this.bannerEl.querySelector('[data-dog-profile-banner-name]');
        const sizeEl = this.bannerEl.querySelector('[data-dog-profile-banner-size]');
        const ageEl = this.bannerEl.querySelector('[data-dog-profile-banner-age]');
        const breedEl = this.bannerEl.querySelector('[data-dog-profile-banner-breed]');
        const countEl = this.bannerEl.querySelector('[data-dog-profile-banner-count]');

        if (nameEl) {
          nameEl.textContent = this.profile.name
            ? `${this.profile.name} ·`
            : this.dataset.yourDogPrefix || 'Your dog:';
        }
        if (sizeEl) sizeEl.textContent = sizeInfo?.label || '';
        if (ageEl) ageEl.textContent = ageInfo?.label || '';
        if (breedEl) {
          const showBreed = isDisplayBreed(this.profile.breed);
          breedEl.textContent = showBreed ? this.profile.breed : '';
          breedEl.hidden = !showBreed;
        }
        if (countEl) {
          const template =
            this.dataset.matchCountLabel || '— [count] products matched';
          countEl.textContent = this.showProductRow
            ? template.replace('[count]', String(matches.length))
            : '';
          countEl.hidden = !this.showProductRow;
        }
      }

      renderProductRow() {
        const hasProfile = Boolean(this.profile);
        const showRowShell = this.showProductRow && hasProfile && !this.expanded;
        const { items: matches, mode } = showRowShell
          ? this.matchingCandidates()
          : { items: [], mode: 'none' };
        const visible = matches.slice(0, this.productsLimit);
        const hasMatches = visible.length > 0;

        this.candidates.forEach((item) => {
          item.hidden = true;
        });
        visible.forEach((item) => {
          item.hidden = false;
        });

        this.rowEl?.toggleAttribute('hidden', !(showRowShell && hasMatches));
        this.emptyEl?.toggleAttribute('hidden', !(showRowShell && !hasMatches));

        const noteEl = this.querySelector('[data-dog-profile-match-note]');
        if (noteEl) {
          const showNote = showRowShell && hasMatches && mode === 'size';
          noteEl.hidden = !showNote;
        }

        if (!showRowShell) return;

        const dogLabel = this.dogLabel();
        const sizeInfo = DOG_PROFILE_SIZES[this.profile.size];
        const ageInfo = DOG_PROFILE_AGES[this.profile.age];
        const showBreed = isDisplayBreed(this.profile.breed);

        this.querySelectorAll('[data-dog-profile-dog-label]').forEach((el) => {
          el.textContent = dogLabel;
        });
        this.querySelectorAll('[data-dog-profile-row-size]').forEach((el) => {
          el.textContent = sizeInfo?.label || '';
        });
        this.querySelectorAll('[data-dog-profile-row-age]').forEach((el) => {
          el.textContent = ageInfo?.label || '';
        });
        this.querySelectorAll('[data-dog-profile-row-breed]').forEach((el) => {
          el.textContent = showBreed ? this.profile.breed : '';
          el.hidden = !showBreed;
        });
        this.querySelectorAll('[data-dog-profile-row-count]').forEach((el) => {
          el.textContent = String(matches.length);
        });

        const viewAll = this.querySelector('[data-dog-profile-view-all]');
        if (viewAll) {
          const template =
            this.dataset.viewAllLabel || 'View all [count] products for [name]';
          viewAll.textContent = template
            .replace('[count]', String(matches.length))
            .replace('[name]', dogLabel);
        }
      }
    }
  );
}

window.DragonflyDogProfile = {
  STORAGE_KEY: DOG_PROFILE_STORAGE_KEY,
  EVENT: DOG_PROFILE_EVENT,
  read: readDogProfile,
};
